// axios
import axios from 'axios'

// Init axios
export default axios.create({
    baseURL: "//"+process.env.VUE_APP_BACKEND_URL,
    headers: {

    }
})
